import React from 'react';
import { Action, ActionProps } from '@doveit/bricks';
import { Contact } from '../../../providers/api/dtos';
import { ReferenceType } from '../../../domain/types';
import { goToDetailPage } from '../../../utils/navigate/utils';
import useUserPermissions from '../../../hooks/use-user-permissions/useUserPermissions';

type ChildFnProps = {
  onClick: VoidFunction,
};

export interface ViewContactActionProps {
  contactId: NonNullable<Contact['id']>,
  size?: ActionProps['size'],
  sameTab?: boolean,
  children?: (props: ChildFnProps) => React.ReactNode,
}

const ViewContactAction: React.FC<ViewContactActionProps> = ({
  contactId,
  size = 'S',
  sameTab = false,
  children,
}) => {
  const userPermissions = useUserPermissions(['contacts']);

  const onClick = React.useCallback(() => {
    goToDetailPage(contactId, ReferenceType.CONTACT, sameTab);
  }, [contactId, sameTab]);

  if (!userPermissions?.contacts.canSee) {
    return null;
  }

  return children
    ? children({ onClick })
    : (
      <Action
        label="Visualizza contatto"
        aria-label="Pulsante per visualizzare la pagina del contatto"
        size={size}
        onClick={onClick}
      />
    );
};

export default ViewContactAction;
